import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Motion } from 'react-motion';
import Color from 'color';
import { FULL_STYLE, RESPONSIVE_SIZE } from '../../constants';
import { compose } from '../../lib/react';
import { springify } from '../../lib/Motion';
import Aspect from '../Aspect';
import ImageLoader from '../ImageLoader';
import { withHover } from '../Hoverable';
import Video from '../Video';
import Style from '../Style';

class ClipPlayer extends React.PureComponent {
  static propTypes = {
    responsive: PropTypes.number,
    hover: PropTypes.bool,
    backgroundColor: PropTypes.string,
    lqip: PropTypes.string,
    thumbnail: PropTypes.string,
    poster: PropTypes.string.isRequired,
    video: PropTypes.string.isRequired,
    colorA: PropTypes.string.isRequired,
    colorB: PropTypes.string.isRequired,
  };
  static defaultProps = {
    hover: false,
    backgroundColor: Style.Colors.black,
  };

  constructor(props) {
    super(props);

    this.state = {
      hover: undefined,
      videoLoaded: false,
      videoPlaying: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.video !== nextProps.video) {
      this.setState({ videoLoaded: false });
    }
  }

  saveRef = el => {
    this.videoElement = el;
  };

  playClicked = e => {
    if (this.videoElement) {
      this.videoElement.play().catch(err => undefined);
    }
  };

  pauseClicked = e => {
    if (this.videoElement) {
      this.videoElement.pause();
    }
  };

  onPlaying = e => {
    this.setState({ videoLoaded: true, videoPlaying: true });
  };

  onPause = e => {
    this.setState({ videoPlaying: false });
  };

  onEnded = e => {
    this.setState({ videoPlaying: false });
  };

  onAbort = e => {
    this.setState({ videoPlaying: false });
  };

  onTogglePlaying = e => {
    if (this.state.videoPlaying) {
      this.pauseClicked(e);
    } else {
      this.playClicked(e);
    }
  };

  render() {
    const {
      responsive,
      hover,
      backgroundColor,
      lqip,
      thumbnail,
      poster,
      video,
      colorA,
      colorB,
      ...otherProps
    } = this.props;

    let borderHover = false;
    if (responsive >= RESPONSIVE_SIZE.TABLET_LANDSCAPE) {
      borderHover = true;
    }

    const backgroundStyle = {
      margin: `calc(${1 * 0.8}vw + (${1}rem * 0.5))`,
      overflow: 'hidden',
      position: 'relative',
      backgroundColor: Style.Colors.black,
      maxWidth: '76rem',
    };

    const videoStyle = {
      ...FULL_STYLE,
      height: 'calc(100% + 1px)',
      cursor: 'pointer',
    };

    let animatedDefault = {
      shadowSpread: 1,
      posterOpacity: 1,
    };
    let animatedCurrent = {
      shadowSpread: hover && borderHover ? 2 : animatedDefault.shadowSpread,
      posterOpacity: this.state.videoLoaded ? 0 : animatedDefault.posterOpacity,
    };

    return (
      <Motion defaultStyle={animatedDefault} style={springify(animatedCurrent)}>
        {tween => {
          // Animated properties.
          const backgroundStyleMerged = {
            ...backgroundStyle,
            boxShadow: `0 0 0 calc(${tween.shadowSpread *
              0.8}vw + (${tween.shadowSpread}rem * 0.5)) ${Color(colorB).alpha(
              0.85,
            )}`,
          };

          return (
            <div style={backgroundStyleMerged} onClick={this.onTogglePlaying}>
              <Aspect ratio={9 / 16}>
                <Video
                  refCallback={this.saveRef}
                  style={videoStyle}
                  poster={poster}
                  src={video}
                  onPlaying={this.onPlaying}
                  onPause={this.onPause}
                  onEnded={this.onEnded}
                  onAbort={this.onAbort}
                />
                <div style={{ opacity: tween.posterOpacity }}>
                  <ImageLoader
                    color={backgroundColor}
                    lqip={lqip}
                    images={[poster, thumbnail]}
                  />
                </div>
              </Aspect>
            </div>
          );
        }}
      </Motion>
    );
  }
}

function mapStateToProps(state) {
  return {
    responsive: state.runtime.responsive,
  };
}

export default compose(withHover(), connect(mapStateToProps))(ClipPlayer);



// WEBPACK FOOTER //
// ./src/components/ClipPlayer/ClipPlayer.js